import { useEffect } from 'react';
import { MdClose, MdInfo } from 'react-icons/md';
import useWhiteLabelSettings from 'hooks/useWhiteLabelSettings';
import Text from '../typography/Text';

export default function MessageModal({
  showModal,
  openModalHandler,
  error = false,
  message = '',
}) {
  const { whiteLabelSettings: { primaryColour } = {} } =
    useWhiteLabelSettings();

  let modalStyle = {
    backgroundColor: primaryColour,
    borderColor: primaryColour,
    color: '#fff',
  };
  if (error) {
    modalStyle = {
      borderColor: primaryColour,
      color: primaryColour,
    };
  }

  useEffect(() => {
    if (showModal) {
      setTimeout(() => {
        openModalHandler();
      }, 5000);
    }
  }, [showModal, openModalHandler]);

  if (!showModal) {
    return null;
  }

  return (
    <div style={modalStyle} className={`popup-message ${error ? 'error' : ''}`}>
      <div className="w-full flex justify-center items-center">
        {error && (
          <div className="mr-2 text-lg">
            <MdInfo />
          </div>
        )}
        <Text>{message}</Text>
      </div>

      <button type="button" onClick={openModalHandler} className="close-popup">
        <MdClose />
      </button>
    </div>
  );
}
